/** @jsxImportSource @emotion/react */
import Search from 'apollo-react/components/Search'

const SearchBar = () => {
  return (
    <form
      action="/search"
      acceptCharset="UTF-8"
      method="GET"
      data-testid="searchForm"
      id="searchForm"
    >
      <Search placeholder="Search" name="header_query" size="small" />
    </form>
  )
}

export default SearchBar
